export * from './graphDigitalOffline.component';
